<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-10 offset-lg-1 mt-4 col-lg-8">
                    <div class="intro col-12 col-md-8">
                        <h2 class="mb-2">Mijn profielpagina</h2>
                        <slot name="introductionText"></slot>
                    </div>

                    <template
                        v-if="actualProfile.ContentTypeAlias === 'advisorCEG'"
                    >
                        <clientdashboard-profile-ceg :profile="actualProfile" />
                    </template>
                    <template
                        v-else-if="actualProfile.ContentTypeAlias === 'school'"
                    >
                        <clientdashboard-profile-school
                            :original-profile="actualProfile"
                        />
                    </template>
                    <template
                        v-else-if="actualProfile.ContentTypeAlias === 'parent'"
                    >
                        <clientdashboard-profile-ouders
                            :profile="actualProfile"
                        />
                    </template>
                    <template
                        v-else-if="actualProfile.ContentTypeAlias === 'teacher'"
                    >
                        <clientdashboard-profile-teacher
                            :profile="actualProfile"
                        />
                    </template>
                    <template
                        v-else-if="actualProfile.ContentTypeAlias === 'bso'"
                    >
                        <clientdashboard-profile-bso :profile="actualProfile" />
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import clientdashboardProfileSchool from './dashboard-profile/clientdashboard-profile-school';
import clientdashboardProfileCeg from './dashboard-profile/clientdashboard-profile-ceg';
import clientdashboardProfileOuders from './dashboard-profile/clientdashboard-profile-ouders';
import clientdashboardProfileTeacher from './dashboard-profile/clientdashboard-profile-teacher';
import clientdashboardProfileBso from './dashboard-profile/clientdashboard-profile-bso';

export default {
    components: {
        clientdashboardProfileSchool,
        clientdashboardProfileCeg,
        clientdashboardProfileOuders,
        clientdashboardProfileBso,
        clientdashboardProfileTeacher
    },
    props: {
        profile: {
            type: String,
            default: ''
        },
        ceg: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            actualProfile: {}
        };
    },
    mounted() {
        this.actualProfile = JSON.parse(this.profile);
    },
    methods: {}
};
</script>
<style></style>
